import { render, staticRenderFns } from "./FilmResults.vue?vue&type=template&id=15fab11b&scoped=true"
import script from "./FilmResults.vue?vue&type=script&lang=ts"
export * from "./FilmResults.vue?vue&type=script&lang=ts"
import style0 from "./FilmResults.vue?vue&type=style&index=0&id=15fab11b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fab11b",
  null
  
)

export default component.exports